// extracted by mini-css-extract-plugin
module.exports = {"alignLeft":"_18xgK","alignRight":"_2xjmF","sizeFullWidth":"_3WMPg","sizeContentWidth":"g-Alr","sizeSmallCenter":"_2I0n1","sizeOriginal":"_2gOQJ"};